var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginMobileBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 599,
    viewBox: "0 0 360 599",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M254 27C262.404 27 270.727 25.3446 278.492 22.1283C286.256 18.9119 293.311 14.1978 299.254 8.25479C305.197 2.31187 309.912 -4.74348 313.128 -12.5082C316.345 -20.2731 318 -28.5954 318 -37C318 -45.4046 316.345 -53.7269 313.128 -61.4918C309.912 -69.2566 305.197 -76.3119 299.254 -82.2548C293.311 -88.1978 286.256 -92.912 278.492 -96.1283C270.727 -99.3446 262.404 -101 254 -101V-37V27Z",
    fill: "#F2F6FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M369.5 27C383.583 27 395 15.5833 395 1.5C395 -12.5833 383.583 -24 369.5 -24C355.417 -24 344 -12.5833 344 1.5C344 15.5833 355.417 27 369.5 27Z",
    fill: "#FFEBA1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M301.5 74C315.583 74 327 62.8071 327 49C327 35.1929 315.583 24 301.5 24C287.417 24 276 35.1929 276 49C276 62.8071 287.417 74 301.5 74Z",
    fill: "#FFFBEC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M369 34C385.568 34 399 47.6553 399 64.5V95H339V64.5C339 47.6553 352.432 34 369 34Z",
    fill: "#F2F6FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M301 82C317.568 82 331 95.4315 331 112V142H271V112C271 95.4315 284.432 82 301 82Z",
    fill: "#F2F6FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8589 442C54.1675 442 64.3756 444.03 73.8992 447.975C83.4228 451.921 92.0767 457.703 99.3662 464.993C106.656 472.282 112.438 480.936 116.383 490.46C120.329 499.983 122.359 510.191 122.359 520.5C122.359 530.809 120.329 541.017 116.383 550.54C112.438 560.064 106.656 568.718 99.3662 576.007C92.0767 583.297 83.4228 589.079 73.8992 593.025C64.3756 596.97 54.1675 599 43.8589 599V442Z",
    fill: "#F2F6FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M-50 520.5H28.5V599C18.1914 599 7.98328 596.97 -1.54033 593.025C-11.064 589.079 -19.7178 583.297 -27.0073 576.007C-34.2969 568.718 -40.0792 560.064 -44.0246 550.54C-47.97 541.017 -50 530.809 -50 520.5Z",
    fill: "#F2F6FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M-3.49709 504.288C-20.6975 504.288 -34.6411 490.344 -34.6411 473.144C-34.6411 455.944 -20.6975 442 -3.49709 442C13.7033 442 27.6469 455.944 27.6469 473.144C27.6469 490.344 13.7033 504.288 -3.49709 504.288Z",
    fill: "#FFFBEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginMobileBg);
export default __webpack_public_path__ + "static/media/login-mobile-bg.32ddcf07b47d5cee8501c627c545a24b.svg";
export { ForwardRef as ReactComponent };